
const initialState = {
    videogames : [],
    allVideogames: [],
    videogame:{},
    genres : [],
    loading : false,
    error : false
}

function rootReducer (state = initialState, action){
    switch(action.type) {
        case "BEFORE_CALL_API":
            return {
                ...state,
                loading: true
            }
        case "GET_VIDEOGAMES":
            return {
                ...state,
                videogames: action.payload,
                allVideogames: action.payload,
                loading: false,
                error: false
            }
        case "GET_GENRES":
            return {
                ...state,
                genres: action.payload
            }
        case "SEARCH_BY_NAME":
            return {
                ...state,
                videogames: action.payload,
                loading: false,
                error: false
            }
        case "VIDEOGAME_DETAIL":
            return {
                ...state,
                videogame: action.payload,
                loading: false,
                error: false
            }
        case "ERROR_API":
            return {
                ...state,
                loading: false,
                error: true
            }
        case "FILTER_BY_GENRE":
            const allVideogame = state.allVideogames
            const filteredByGenre = action.payload === "All" ? allVideogame : allVideogame.filter(element => element.genres.filter(el => el == action.payload) == action.payload )
            return {
                ...state,
                videogames: filteredByGenre
            }
        case "FILTER_BY_CREATED":
            const allVideogamesc = state.allVideogames
            let filteredByCreated = []
            if(action.payload === "All") {filteredByCreated = allVideogamesc}
            else if(action.payload === "db") {filteredByCreated = allVideogamesc.filter(elem => elem.created == action.payload)}
            else if(action.payload === "api") {filteredByCreated = allVideogamesc.filter(elem => elem.created == action.payload)}
            
            return {
                ...state,
                videogames: filteredByCreated
            }
        case "FILTER_BY_NAME":
            const allVideogames = state.allVideogames
            const filteredByName = action.payload === "ascending" 
            ? allVideogames.sort((a,b) => {
                if(a.name<b.name) return -1
                else if(a.name>b.name) return 1
                else return 0
            }) 
            : allVideogames.sort((a,b) => {
                if(a.name>b.name) return -1
                else if(a.name<b.name) return 1
                else return 0
            }) 
            return {
                ...state,
                videogames: filteredByName
            }
        default:
            return state
    }
}

export default rootReducer;